import { createAction } from '@reduxjs/toolkit';
import type { IVirusDialogRequest } from 'reactApp/modules/popup/popup.types';

export const showVirusDlg = createAction<IVirusDialogRequest>('popups/showVirusDlg');
